export const SHARE_NOW_ONBOARDING_SKIPPED_KEY = 'sn.ltcs.storage.onboardingSkipped';
export const SHARE_NOW_SHOW_ONBOARDING_KEY = 'sn.ltcs.storage.onboarding';
export const MB_RENT_ONBOARDING_SKIPPED_KEY = 'MB_RENT_ONBOARDING_SKIPPED';
export const MB_RENT_SHOW_ONBOARDING_KEY = 'MB_RENT_SHOW_ONBOARDING';
export const REGISTRATION_DATA_KEY = 'sn.ltcs.registration';
